// lib/api/client.ts
import createClient, {type Middleware} from "openapi-fetch";
import type {paths} from "@/openapi/generated";
import {PHASE_PRODUCTION_BUILD} from "next/constants";
import {getFirebaseAuth} from "@/lib/firebase/client-app";
import {idTokenReady} from "@/lib/firebase/ready";

async function getFirebaseJwt(): Promise<string | undefined> {
    if (typeof window !== "undefined") {
        // ensure init has run
        await idTokenReady();
        const firebaseAuth = getFirebaseAuth()
        const user = firebaseAuth.currentUser;
        return user ? user.getIdToken() : undefined;
    } else {
        // SERVER: dynamically import so you don’t blow up your client bundle
        const {cookies} = await import("next/headers");
        const cookieList = await cookies();
        return cookieList.get("__session")?.value;
    }
}

const authenticatingMiddleware: Middleware = {
    async onRequest({request}) {

        // Skip auth in static generation (build) mode to avoid usage of cookies.
        if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
            return request;
        }

        const token = await getFirebaseJwt();

        if (token) {
            request.headers.set("Authorization", `Bearer ${token}`);
        }
        return request;
    },

    onResponse: async ({response}) => {
        if (!response.ok) {


            let responseJsonStr = ""

            try {
                const responseJson = await response.json()
                if (responseJson) {
                    responseJsonStr = JSON.stringify(responseJson)
                }
            } catch (e) {
                console.error(e);
            }

            throw new Error(`${response.url}: ${response.status} ${response.statusText} ${responseJsonStr}`);
        }
        return response;
    },

    onError({error}) {
        return new Error("Oops", {cause: error});
    },
};

// Authenticated server API client (uses cookies, makes requests dynamic)
export const serverApi = createClient<paths, "*/*">({
    baseUrl: process.env.NEXT_PUBLIC_DONISTA_INTERNAL_API_URL!,
});
serverApi.use(authenticatingMiddleware);

// Note: For cacheable public requests, use the existing 'api' client from openapi/client.ts
// It's already configured without auth middleware and is safe for caching




